import React from "react";
import "./style.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DetailBanner from "../DetailBanner";
import Details from "../Details";
import Guidelines from "../Guidelines";
import ChampionVideos from "../ChampionVideos";
import Submission from "../Submission";
import { URLRegex, isValidString } from "../../../../../../../helper";
import placehoderImg from "../../../../../../../Assets/Images/placeholder_img_512.png"

const QuizTabs = ({ data }) => {

  return (
    <div className="chmpn-detail-tabs px-5">
      <div className="participent-skills-tab">
        <Tabs defaultActiveKey="activitydescription" id="uncontrolled-tab-example" className="mb-3">
          <Tab eventKey="activitydescription" title="Activity Description">
            <div className="details-banner">
              <div class="post-banner">
                <img src={isValidString(data?.activityDetails?.mediaList[0]?.url) ? data?.activityDetails?.mediaList[0]?.url : placehoderImg} alt="detailsBanner" style={{ width: "100%", height: "320px", objectFit: "cover" }} />
              </div>
            </div>
            <Details data={data} />
            <Guidelines data={data} />
          </Tab>
          <Tab eventKey="watchvideos" title="Watch videos">
            {data?.activityDetails?.youtube?.map(item => {
              const videoSrc = URLRegex.test(item.url) ? item.url : `https://www.youtube.com/embed/${item.url}`;
              return <ChampionVideos URL={videoSrc} title={item?.title} />
            })}
          </Tab>
          <Tab eventKey="submission" title="Submission">
            <Submission data={data} />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default QuizTabs;
